<template>
  <div class="featured-services-data-wrapper">
    <slot :services="featuredServiceList" />
  </div>
</template>

<script>
import dataWrapper from '@/mixins/data_wrapper'

import {mapActions, mapGetters, mapState} from 'vuex'

const MAX_SERVICES = 3

export default {
  name: 'FeaturedServicesDataWrapper',

  mixins: [dataWrapper],

  computed: {
    ...mapGetters(['featuredTagId']),

    ...mapState([
      'tagsListedAt',
      'featuredServiceList',
      'featuredServicesListedAt'
    ]),

    shouldGetFeaturedServices() {
      return this.resourceStale(this.featuredServicesListedAt)
    },

    shouldListTags() {
      return this.resourceStale(this.tagsListedAt)
    }
  },

  methods: {
    ...mapActions(['listTags', 'listFeaturedServices']),

    getData() {
      const tagId = this.featuredTagId
      const params = {per_page: MAX_SERVICES}
      return this.listFeaturedServices({params, tagId})
    },

    updateData() {
      if (this.shouldGetFeaturedServices) {
        if (this.shouldListTags) {
          this.listTags().then(() => {
            this.getData()
          })
        } else {
          this.getData()
        }
      }
    }
  },

  serverPrefetch() {
    return this.listTags().then(() => {
      return this.getData()
    })
  },

  mounted() {
    this.updateData()
  },

  watch: {
    $route() {
      this.updateData()
    }
  }
}
</script>

<style lang="sass" scoped>
.featured-services-data-wrapper
</style>
